import { render, staticRenderFns } from "./dialogVideo.vue?vue&type=template&id=4347b762&"
import script from "./dialogVideo.vue?vue&type=script&lang=js&"
export * from "./dialogVideo.vue?vue&type=script&lang=js&"
import style0 from "./dialogVideo.vue?vue&type=style&index=0&id=4347b762&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports